if (!customElements.get('product-card-atc')) {
    class ComponentProductCardAtc extends HTMLElement {
        constructor() {
            super()
            this.productData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
            this.swatches = this.querySelector('.swatch-group')
            this.addEventListener('variantChange', this.onVariantChange.bind(this));
            this.defaultImage = this.querySelector('.img.main').getAttribute('data-srcset');
            if (this.classList.contains('colors-out')) {
                this.colorSwatches = this.querySelector('product-swatch.color-swatches');
                if (this.colorSwatches) {
                    this.querySelector('add-to-cart-form').insertAdjacentElement('afterbegin', this.colorSwatches);
                }
            }

        }

        onVariantChange(event) {
            var image = event.detail.variant.featured_image;
            var img = this.querySelector('.img.main');
            var width = Math.ceil(img.width / 100) * 100;
            img.setAttribute('srcset', image ? $s.imgUrlFilter(image.src, width + 'x') : this.defaultImage)
        }
    }
    customElements.define('product-card-atc', ComponentProductCardAtc);
}